package horcrux.common.api.dtos.types

import kotlinx.serialization.Serializable

@Serializable
sealed interface ProcessedDocument

@Serializable
data object ProcessedContainerDocument : ProcessedDocument

@Serializable
sealed interface ProcessedContentDocument: ProcessedDocument

@Serializable
data class ProcessedImageDocument(override val value: ByteArray) : ProcessedContentDocument, ImageDocument {
    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false

        other as ProcessedImageDocument

        return value.contentEquals(other.value)
    }

    override fun hashCode(): Int {
        return value.contentHashCode()
    }
}

@Serializable
data class ProcessedTextDocument(override val value: String) : ProcessedContentDocument, TextDocument
